import { TFunction } from 'next-i18next'
import { Withdrawal, WithdrawalFilter } from '../models'

export const getWithdrawalUserName = (withdrawal: Withdrawal): string => {
  return `${withdrawal.user_name} ${withdrawal.user_lastname}`
}

export const getWithdrawalCompany = (withdrawal: Withdrawal): string => {
  const company =  withdrawal.user_company
  return withdrawal.user_type === 'individual' ? '-' : company ? company : '-'
}

export const getWithdrawalStatusTags = (
  t: TFunction, withdrawal: Withdrawal
) => {
  const status = {
    paid: { label: t('developers.Completed'), type: 'success' },
    pending: { label: t('Deposits.Pending'), type: 'processing' },
    canceled: { label: t('general.Cancelled'), type: 'error' }
  }[withdrawal.status]

  return status
}

export const getFilteredWithdrawals = (filters: WithdrawalFilter, withdrawals: Withdrawal[]): Withdrawal[] => {
  let newWithdrawals: Withdrawal[] = withdrawals

  // Filter By Text
  if (filters.text) {
    const text = filters.text?.toLowerCase()
    newWithdrawals = newWithdrawals.filter((withdrawal: Withdrawal)=> {
      return (
        getWithdrawalUserName(withdrawal)?.toLowerCase().includes(text) ||
        withdrawal.status.toLowerCase().includes(text) ||
        `${withdrawal.total}`?.toLowerCase().includes(text) ||
        getWithdrawalCompany(withdrawal)?.toLowerCase().includes(text)
      )
    })
  }

  // Filter by Status
  if (filters.status !== 'ALL') {
    const status = filters.status
    if (status === 'pending') { newWithdrawals = newWithdrawals.filter(u => u.status === 'pending' ) }
  }

  return newWithdrawals
}
